import Details from "./Details"

const index = {
    Details
}

export default index;
